import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'defaultValue',
  standalone: true,
})
export class DefaultValuePipe implements PipeTransform {
  transform(value: string, defaultValue = '-'): string {
    if (!value) {
      return defaultValue;
    }

    return value;
  }
}
